/**
 * LoginCredentials value object
 * Represents the credentials required for authentication
 */
export interface LoginCredentials {
  readonly email: string;
  readonly password: string;
}

/**
 * Factory function to create LoginCredentials
 */
export const createLoginCredentials = (email: string, password: string): LoginCredentials => {
  if (!email || email.trim().length === 0) {
    throw new Error('Email is required');
  }

  if (!password || password.trim().length === 0) {
    throw new Error('Password is required');
  }

  return {
    email: email.trim(),
    password: password,
  };
};
